import React from 'react';
import { Search, Filter, MessageCircle, Users, Briefcase, Clock, CheckCircle, AlertCircle } from 'lucide-react';
import ChatItem from '../ChatItem/ChatItem';
import '../Chat.scss';

const ChatList = ({
  conversations,
  selectedId,
  onSelect,
  loading,
  searchTerm,
  onSearchChange,
  filter,
  onFilterChange,
  type,
  onClose
}) => {
  const filters = [
    { id: 'all', label: 'Todas', icon: MessageCircle },
    { id: 'active', label: 'Ativas', icon: Clock },
    { id: 'closed', label: 'Fechadas', icon: CheckCircle },
  ];

  const getTitle = () => {
    if (type === 'job') {
      return {
        title: 'Chat das Vagas',
        subtitle: 'Suas conversas sobre vagas',
        icon: Briefcase
      };
    }
    return {
      title: 'Suporte',
      subtitle: 'Conversas com o suporte',
      icon: Users
    };
  };

  const title = getTitle();
  const Icon = title.icon;

  if (loading) {
    return (
      <div className="chat-list__loading">
        <div className="chat-list__spinner" />
        <span>Carregando conversas...</span>
      </div>
    );
  }

  return (
    <div className="chat-list">
      {/* Header */}
      <div className="chat-list__header">
        <div className="chat-list__title">
          <Icon size={20} />
          <div>
            <h2>{title.title}</h2>
            <span>{title.subtitle}</span>
          </div>
        </div>
        {/* {onClose && (
          <button className="chat-list__close" onClick={onClose}>
            ×
          </button>
        )} */}
      </div>

      {/* Search */}
      <div className="chat-list__search">
        <Search size={16} />
        <input
          type="text"
          placeholder="Buscar conversas..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      {/* Filters */}
      <div className="chat-list__filters">
        {filters.map((f) => {
          const FilterIcon = f.icon;
          const isActive = filter === f.id;
          return (
            <button
              key={f.id}
              className={`chat-list__filter ${isActive ? 'chat-list__filter--active' : ''}`}
              onClick={() => onFilterChange(f.id)}
            >
              <FilterIcon size={14} />
              {f.label}
              {isActive && conversations.length > 0 && (
                <span className="chat-list__filter-count">{conversations.length}</span>
              )}
            </button>
          );
        })}
      </div>

      {/* List */}
      <div className="chat-list__items">
        {conversations.length === 0 ? (
          <div className="chat-list__empty">
            <MessageCircle size={32} />
            <h4>Nenhuma conversa encontrada</h4>
            <p>
              {searchTerm 
                ? 'Tente buscar por outro termo' 
                : 'Suas conversas aparecerão aqui'}
            </p>
          </div>
        ) : (
          conversations.map((conversation) => (
            <ChatItem
              key={conversation.id}
              conversation={conversation}
              isSelected={selectedId === conversation.id}
              onClick={() => onSelect(conversation)}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ChatList;